"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[8800,7911],{

/***/ 77911:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(68777);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(85893);






var Button = function Button(_ref) {
  var onSubmit = _ref.onSubmit,
      text = _ref.text,
      src = _ref.src,
      img = _ref.img,
      hoverImg = _ref.hoverImg,
      fontSize = _ref.fontSize,
      fontWeight = _ref.fontWeight,
      color = _ref.color,
      letterSpacing = _ref.letterSpacing,
      lineHeight = _ref.lineHeight,
      margin = _ref.margin,
      background = _ref.background,
      borderRadius = _ref.borderRadius,
      border = _ref.border,
      width = _ref.width,
      height = _ref.height,
      hoverBackground = _ref.hoverBackground,
      target = _ref.target,
      borderColor = _ref.borderColor,
      hoverColor = _ref.hoverColor,
      icon = _ref.icon,
      newtablink = _ref.newtablink,
      svgwidth = _ref.svgwidth,
      popup = _ref.popup,
      ex = _ref.ex;
  var svgOne = "\n    <svg id=\"Button_-_Contact_Us\" data-name=\"Button - Contact Us\" xmlns=\"http://www.w3.org/2000/svg\" width=\"".concat(svgwidth ? svgwidth : '170', "\" height=\"44\" viewBox=\"0 0 ").concat(svgwidth ? svgwidth : '170', " 44\">\n        <g id=\"Rectangle_492\" data-name=\"Rectangle 492\" fill=\"none\" stroke=\"").concat(color ? color : '#3C3C3B', "\" strokeWidth=\"1\" opacity=\"0.5\">\n            <rect width=\"").concat(svgwidth ? svgwidth : '170', "\" height=\"44\" rx=\"22\" stroke=\"none\"/>\n            <rect x=\"0.5\" y=\"0.5\" width=\"").concat(svgwidth ? svgwidth - 1 : '169', "\" height=\"43\" rx=\"21.5\" fill=\"none\"/>\n        </g>\n        <g id=\"Rectangle_493\" data-name=\"Rectangle 493\" fill=\"none\" stroke=\"").concat(color ? color : '#3C3C3B', "\" strokeWidth=\"1\" strokeDasharray=\"0 520\" opacity=\"0\">\n            <rect width=\"").concat(svgwidth ? svgwidth : '170', "\" height=\"44\" rx=\"22\" stroke=\"none\"/>\n            <rect x=\"0.5\" y=\"0.5\" width=\"").concat(svgwidth ? svgwidth - 1 : '169', "\" height=\"43\" rx=\"21.5\" fill=\"none\"/>\n        </g>\n        <g id=\"Group_4825\" data-name=\"Group 4825\" transform=\"translate(36 12)\">\n            <text id=\"Contact_Us\" data-name=\"Contact Us\" transform=\"").concat(svgwidth ? 'translate(-5 15)' : 'translate(0 15)', "\" fill=\"").concat(color ? color : '#3C3C3B', "\" font-size=\"16\" font-family=\"Avenir-Medium, Avenir\" font-weight=\"500\">\n                <tspan x=\"").concat(popup ? '-10' : '0', "\" y=\"0\">").concat(text, "</tspan>\n            </text>\n            <g id=\"Group_4824\" data-name=\"Group 4824\" transform=\"").concat(svgwidth ? 'translate(135 4.5)' : ex ? "translate(97 4.5)" : 'translate(95 4.5)', "\">\n                <g id=\"Group_4823\" data-name=\"Group 4823\" transform=\"translate(5)\">\n                    <line id=\"Line_9\" data-name=\"Line 9\" x2=\"5\" y2=\"5\" fill=\"none\" stroke=\"").concat(color ? color : '#3C3C3B', "\" strokeLinecap=\"round\" strokeWidth=\"1\"/>\n                    <line id=\"Line_10\" data-name=\"Line 10\" x1=\"5\" y2=\"5\" transform=\"translate(0 5)\" fill=\"none\" stroke=\"").concat(color ? color : '#3C3C3B', "\" strokeLinecap=\"round\" strokeWidth=\"1\"/>\n                </g>\n                <line id=\"Line_11\" data-name=\"Line 11\" x2=\"10\" transform=\"translate(0 5)\" fill=\"none\" stroke=\"").concat(color ? color : '#3C3C3B', "\" strokeLinecap=\"round\" strokeWidth=\"1\"/>\n            </g>\n        </g>\n    </svg>");
  var svgTwo = "\n    <svg id=\"Button_-_Open_an_Account_Now\" data-name=\"Button - Open an Account Now\" xmlns=\"http://www.w3.org/2000/svg\" width=\"238\" height=\"44\" viewBox=\"0 0 238 44\">\n      <g id=\"Rectangle_492\" data-name=\"Rectangle 492\" fill=\"none\" stroke=\"#fff\" strokeWidth=\"1\" opacity=\"0.3\">\n        <rect width=\"238\" height=\"44\" rx=\"22\" stroke=\"none\"/>\n        <rect x=\"0.5\" y=\"0.5\" width=\"237\" height=\"43\" rx=\"21.5\" fill=\"none\"/>\n      </g>\n      <g id=\"Rectangle_493\" data-name=\"Rectangle 493\" fill=\"none\" stroke=\"#fff\" strokeWidth=\"1\" strokeDasharray=\"2 520\" opacity=\"0\">\n        <rect width=\"238\" height=\"44\" rx=\"22\" stroke=\"none\"/>\n        <rect x=\"0.5\" y=\"0.5\" width=\"237\" height=\"43\" rx=\"21.5\" fill=\"none\"/>\n      </g>\n      <text id=\"Open_an_Account_Now\" data-name=\"Open an Account Now\" transform=\"translate(36 27)\" fill=\"#fff\" fontSize=\"16\" fontFamily=\"Avenir-Medium, Avenir\" fontWeight=\"500\">\n        <tspan x=\"".concat(popup ? '-10' : '0', "\" y=\"0\">").concat(text, "</tspan>\n      </text>\n    </svg>");
  var svgThree = "\n    <svg id=\"Button_-_Contact_Us\" data-name=\"Button - Contact Us\" xmlns=\"http://www.w3.org/2000/svg\" width=\"170\" height=\"44\" viewBox=\"0 0 170 44\">\n      <g id=\"Rectangle_492\" data-name=\"Rectangle 492\" fill=\"none\" stroke=\"".concat(color ? color : 'white', "\" strokeWidth=\"1\" opacity=\"0.5\">\n        <rect width=\"170\" height=\"44\" rx=\"22\" stroke=\"none\"/>\n        <rect x=\"0.5\" y=\"0.5\" width=\"169\" height=\"43\" rx=\"21.5\" fill=\"none\"/>\n      </g>\n      <g id=\"Rectangle_493\" data-name=\"Rectangle 493\" fill=\"none\" stroke=\"").concat(color ? color : 'white', "\" strokeWidth=\"1\" strokeDasharray=\"0 520\" opacity=\"0\">\n        <rect width=\"170\" height=\"44\" rx=\"22\" stroke=\"none\"/>\n        <rect x=\"0.5\" y=\"0.5\" width=\"169\" height=\"43\" rx=\"21.5\" fill=\"none\"/>\n      </g>\n      <g id=\"Group_4825\" data-name=\"Group 4825\" transform=\"translate(36 12)\">\n        <text id=\"Contact_Us\" data-name=\"Contact Us\" transform=\"translate(0 15)\" fill=\"").concat(color ? color : 'white', "\" fontSize=\"16\" fontFamily=\"Avenir-Medium, Avenir\" fontWeight=\"500\">\n          <tspan x=\"").concat(popup ? '-10' : '0', "\" y=\"0\">").concat(text, "</tspan>\n        </text>\n        <g id=\"Group_4824\" data-name=\"Group 4824\" transform={ex ? \"translate(97 4.5)\" :\"translate(92 4.5)\"}>\n          <g id=\"Group_4823\" data-name=\"Group 4823\" transform=\"translate(5)\">\n            <line id=\"Line_9\" data-name=\"Line 9\" x2=\"5\" y2=\"5\" fill=\"none\" stroke=\"").concat(color ? color : 'white', "\" strokeLinecap=\"round\" strokeWidth=\"1\"/>\n            <line id=\"Line_10\" data-name=\"Line 10\" x1=\"5\" y2=\"5\" transform=\"translate(0 5)\" fill=\"none\" stroke=\"").concat(color ? color : 'white', "\" strokeLinecap=\"round\" strokeWidth=\"1\"/>\n          </g>\n          <line id=\"Line_11\" data-name=\"Line 11\" x2=\"10\" transform=\"translate(0 5)\" fill=\"none\" stroke=\"").concat(color ? color : 'white', "\" strokeLinecap=\"round\" strokeWidth=\"1\"/>\n        </g>\n      </g>\n    </svg>");
  var svgFour = "\n    <svg id=\"Button_-_Open_an_Account_Now\" data-name=\"Button - Open an Account Now\" xmlns=\"http://www.w3.org/2000/svg\" width=\"238\" height=\"44\" viewBox=\"0 0 238 44\">\n      <g id=\"Rectangle_492\" data-name=\"Rectangle 492\" fill=\"none\" stroke=\"#fff\" strokeWidth=\"1\" opacity=\"0.3\">\n        <rect width=\"238\" height=\"44\" rx=\"22\" stroke=\"none\"/>\n        <rect x=\"0.5\" y=\"0.5\" width=\"237\" height=\"43\" rx=\"21.5\" fill=\"none\"/>\n      </g>\n      <g id=\"Rectangle_493\" data-name=\"Rectangle 493\" fill=\"none\" stroke=\"#fff\" strokeWidth=\"1\" strokeDasharray=\"2 520\" opacity=\"0\">\n        <rect width=\"238\" height=\"44\" rx=\"22\" stroke=\"none\"/>\n        <rect x=\"0.5\" y=\"0.5\" width=\"237\" height=\"43\" rx=\"21.5\" fill=\"none\"/>\n      </g>\n      <text id=\"Open_an_Account_Now\" data-name=\"Open an Account Now\" transform=\"translate(36 27)\" fill=\"#fff\" fontSize=\"16\" fontFamily=\"Avenir-Medium, Avenir\" fontWeight=\"500\">\n        <tspan x=\"".concat(popup ? '-10' : '0', "\" y=\"0\">").concat(text, "</tspan>\n      </text>\n    </svg>");
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(StyledBtn, {
    className: "dc-btn ",
    fontSize: fontSize,
    fontWeight: fontWeight,
    color: color,
    background: background,
    lineHeight: lineHeight,
    letterSpacing: letterSpacing,
    margin: margin,
    border: border,
    img: img,
    borderRadius: borderRadius,
    width: width,
    hoverImg: hoverImg,
    hoverBackground: hoverBackground,
    height: height,
    borderColor: borderColor,
    target: target,
    hoverColor: hoverColor,
    onSubmit: onSubmit,
    children: src ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
      href: src || '/',
      target: target || '_self',
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("a", {
        children: icon ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("div", {
          dangerouslySetInnerHTML: {
            __html: svgOne
          }
        }) : /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)("svg", {
          id: "Button_-_Open_an_Account_Now",
          "data-name": "Button - Open an Account Now",
          xmlns: "http://www.w3.org/2000/svg",
          width: "238",
          height: "44",
          viewBox: "0 0 238 44",
          children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)("g", {
            id: "Rectangle_492",
            "data-name": "Rectangle 492",
            fill: "none",
            stroke: "#fff",
            strokeWidth: "1",
            opacity: "0.3",
            children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("rect", {
              width: "238",
              height: "44",
              rx: "22",
              stroke: "none"
            }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("rect", {
              x: "0.5",
              y: "0.5",
              width: "237",
              height: "43",
              rx: "21.5",
              fill: "none"
            })]
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)("g", {
            id: "Rectangle_493",
            "data-name": "Rectangle 493",
            fill: "none",
            stroke: "#fff",
            strokeWidth: "1",
            strokeDasharray: "2 520",
            opacity: "0",
            children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("rect", {
              width: "238",
              height: "44",
              rx: "22",
              stroke: "none"
            }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("rect", {
              x: "0.5",
              y: "0.5",
              width: "237",
              height: "43",
              rx: "21.5",
              fill: "none"
            })]
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("text", {
            id: "Open_an_Account_Now",
            "data-name": "Open an Account Now",
            transform: "translate(36 27)",
            fill: "#fff",
            "font-size": "16",
            "font-family": "Avenir-Medium, Avenir",
            "font-weight": "500",
            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("tspan", {
              x: "".concat(popup ? '-10' : '0'),
              y: "0",
              children: text
            })
          })]
        }) // <div dangerouslySetInnerHTML={{ __html: svgTwo }} />

      })
    }) : newtablink ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("a", {
      href: newtablink,
      target: target || '_self',
      children: icon ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)("svg", {
        id: "Button_-_Contact_Us",
        "data-name": "Button - Contact Us",
        xmlns: "http://www.w3.org/2000/svg",
        width: "170",
        height: "44",
        viewBox: "0 0 170 44",
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)("g", {
          id: "Rectangle_492",
          "data-name": "Rectangle 492",
          fill: "none",
          stroke: "".concat(color ? color : 'white'),
          strokeWidth: "1",
          opacity: "0.5",
          children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("rect", {
            width: "170",
            height: "44",
            rx: "22",
            stroke: "none"
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("rect", {
            x: "0.5",
            y: "0.5",
            width: "169",
            height: "43",
            rx: "21.5",
            fill: "none"
          })]
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)("g", {
          id: "Rectangle_493",
          "data-name": "Rectangle 493",
          fill: "none",
          stroke: "".concat(color ? color : 'white'),
          strokeWidth: "1",
          strokeDasharray: "0 520",
          opacity: "0",
          children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("rect", {
            width: "170",
            height: "44",
            rx: "22",
            stroke: "none"
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("rect", {
            x: "0.5",
            y: "0.5",
            width: "169",
            height: "43",
            rx: "21.5",
            fill: "none"
          })]
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)("g", {
          id: "Group_4825",
          "data-name": "Group 4825",
          transform: "translate(36 12)",
          children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("text", {
            id: "Contact_Us",
            "data-name": "Contact Us",
            transform: "translate(0 15)",
            fill: "".concat(color ? color : 'white'),
            "font-size": "16",
            "font-family": "Avenir-Medium, Avenir",
            "font-weight": "500",
            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("tspan", {
              x: "".concat(popup ? '-10' : '0'),
              y: "0",
              children: text
            })
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)("g", {
            id: "Group_4824",
            "data-name": "Group 4824",
            transform: ex ? "translate(97 4.5)" : "translate(95 4.5)",
            children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)("g", {
              id: "Group_4823",
              "data-name": "Group 4823",
              transform: "translate(5)",
              children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("line", {
                id: "Line_9",
                "data-name": "Line 9",
                x2: "5",
                y2: "5",
                fill: "none",
                stroke: "".concat(color ? color : 'white'),
                strokeLinecap: "round",
                strokeWidth: "1"
              }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("line", {
                id: "Line_10",
                "data-name": "Line 10",
                x1: "5",
                y2: "5",
                transform: "translate(0 5)",
                fill: "none",
                stroke: "".concat(color ? color : 'white'),
                strokeLinecap: "round",
                strokeWidth: "1"
              })]
            }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("line", {
              id: "Line_11",
              "data-name": "Line 11",
              x2: "10",
              transform: "translate(0 5)",
              fill: "none",
              stroke: "".concat(color ? color : 'white'),
              strokeLinecap: "round",
              strokeWidth: "1"
            })]
          })]
        })]
      }) // <div dangerouslySetInnerHTML={{ __html: svgThree }} />
      : /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)("svg", {
        id: "Button_-_Open_an_Account_Now",
        "data-name": "Button - Open an Account Now",
        xmlns: "http://www.w3.org/2000/svg",
        width: "238",
        height: "44",
        viewBox: "0 0 238 44",
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)("g", {
          id: "Rectangle_492",
          "data-name": "Rectangle 492",
          fill: "none",
          stroke: "#fff",
          strokeWidth: "1",
          opacity: "0.3",
          children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("rect", {
            width: "238",
            height: "44",
            rx: "22",
            stroke: "none"
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("rect", {
            x: "0.5",
            y: "0.5",
            width: "237",
            height: "43",
            rx: "21.5",
            fill: "none"
          })]
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)("g", {
          id: "Rectangle_493",
          "data-name": "Rectangle 493",
          fill: "none",
          stroke: "#fff",
          strokeWidth: "1",
          strokeDasharray: "2 520",
          opacity: "0",
          children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("rect", {
            width: "238",
            height: "44",
            rx: "22",
            stroke: "none"
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("rect", {
            x: "0.5",
            y: "0.5",
            width: "237",
            height: "43",
            rx: "21.5",
            fill: "none"
          })]
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("text", {
          id: "Open_an_Account_Now",
          "data-name": "Open an Account Now",
          transform: "translate(36 27)",
          fill: "#fff",
          "font-size": "16",
          "font-family": "Avenir-Medium, Avenir",
          "font-weight": "500",
          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("tspan", {
            x: "".concat(popup ? '-10' : '0'),
            y: "0",
            children: text
          })
        })]
      }) // <div dangerouslySetInnerHTML={{ __html: svgFour }} />

    }) : /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("a", {
      target: target || '_self',
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("span", {
        children: text
      })
    })
  });
};

var StyledBtn = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "ButtonNormal__StyledBtn",
  componentId: "sc-hzc75b-0"
})(["&.dc-btn{margin:", ";width:", ";height:", "px;cursor:pointer;a{display:flex;width:fit-content;height:100%;align-items:center;justify-content:center;font-size:", "px;font-weight:", ";margin:0;line-height:", "px;background-color:", ";position:relative;border-radius:", "px;overflow:hidden;z-index:0;transition:border 1s cubic-bezier(.25,.74,.22,.99);box-sizing:border-box;color:", ";svg{width:auto;height:100%;#Rectangle_493{transition:all 1s cubic-bezier(.25,.74,.22,.99);}}span{transition:color 1s cubic-bezier(.25,.74,.22,.99);color:", ";position:relative;margin-top:5px;z-index:2;line-height:45px;}@keyframes dash{from{stroke-dashoffset:0;}to{stroke-dashoffset:550px;}}&:hover{svg{line{stroke:", ";}#Rectangle_493{opacity:1;strokeDasharray:550px;}}&:before{transform:translate(0);}}&:focus{color:#222222;}&:hover{color:#222222;}}.ok{position:absolute;left:0;top:0;width:100%;height:100%;overflow:visible;transform:translateX(0.25px);margin:0;rect{rx:calc(20 / 2);ry:calc(20 / 2);stroke:#3C3C3B;}}}"], function (props) {
  return props.margin || '0';
}, function (props) {
  return props.width || '100%';
}, function (props) {
  return props.height || '44';
}, function (props) {
  return props.fontSize || '16';
}, function (props) {
  return props.fontWeight || 500;
}, function (props) {
  return props.lineHeight || '24';
}, function (props) {
  return props.background || "transparent";
}, function (props) {
  return props.borderRadius || '22';
}, function (props) {
  return props.color || "#3C3C3B";
}, function (props) {
  return props.color || "#3C3C3B";
}, function (props) {
  return props.hoverColor || '#FFF';
});
/* harmony default export */ __webpack_exports__["default"] = (/*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.memo(Button));

/***/ }),

/***/ 69589:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(68777);
/* harmony import */ var react_bootstrap__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(10682);
/* harmony import */ var react_bootstrap__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(21608);
/* harmony import */ var react_bootstrap__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(31555);
/* harmony import */ var _styles_globalStyleVars__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(68312);
/* harmony import */ var react_html_parser__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(30653);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _ImgP__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(98508);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(5152);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_dynamic__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var gsap__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(62642);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(85893);





 // import Button from "./ButtonNormal";







var Button = next_dynamic__WEBPACK_IMPORTED_MODULE_3___default()(function () {
  return __webpack_require__.e(/* import() */ 7911).then(__webpack_require__.bind(__webpack_require__, 77911));
}, {
  ssr: false,
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(77911)];
    }
  }
});

var SpecialtyLube = function SpecialtyLube(_ref) {
  var _section_image$list, _section_image$list$, _section_image$list2, _section_image$list2$, _section_image$list3, _section_image$list3$, _section_image$list4, _section_image$list4$, _section_image$list5, _section_image$list5$;

  var offset = _ref.offset,
      img = _ref.img,
      data = _ref.data,
      no = _ref.no,
      winWidth = _ref.winWidth;
  var section_data = data === null || data === void 0 ? void 0 : data.section_data;
  var section_image = data === null || data === void 0 ? void 0 : data.images;
  var location = (0,next_router__WEBPACK_IMPORTED_MODULE_4__.useRouter)();
  (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function () {
    // Use GSAP to animate opacity from 0 to 1
    gsap__WEBPACK_IMPORTED_MODULE_6__/* .gsap.to */ .p8.to('.hide', {
      alpha: 1,
      visibility: 'visible',
      display: 'block',
      duration: 0.5,
      delay: 1
    });
  }, [location.pathname]); // Run this effect only once when the component mounts

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.Fragment, {
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsxs)(StyledLube, {
      offset: offset,
      className: "specialty-lube ",
      children: [section_image !== null && section_image !== void 0 && (_section_image$list = section_image.list) !== null && _section_image$list !== void 0 && (_section_image$list$ = _section_image$list[0]) !== null && _section_image$list$ !== void 0 && _section_image$list$.full_path ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(_ImgP__WEBPACK_IMPORTED_MODULE_2__/* .Img */ .E, {
        src: section_image !== null && section_image !== void 0 && (_section_image$list2 = section_image.list) !== null && _section_image$list2 !== void 0 && (_section_image$list2$ = _section_image$list2[0]) !== null && _section_image$list2$ !== void 0 && _section_image$list2$.full_path ? section_image === null || section_image === void 0 ? void 0 : (_section_image$list3 = section_image.list) === null || _section_image$list3 === void 0 ? void 0 : (_section_image$list3$ = _section_image$list3[0]) === null || _section_image$list3$ === void 0 ? void 0 : _section_image$list3$.full_path : 'https://res.cloudinary.com/dgxoa4a9i/image/upload/page/shanta-easytrade/1686937289h8eHd.webp',
        alt: 'Shanta Securities Limited',
        objectFit: 'cover',
        layout: 'fill'
      }) : /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(_ImgP__WEBPACK_IMPORTED_MODULE_2__/* .Img */ .E, {
        src: section_image !== null && section_image !== void 0 && (_section_image$list4 = section_image.list) !== null && _section_image$list4 !== void 0 && (_section_image$list4$ = _section_image$list4[0]) !== null && _section_image$list4$ !== void 0 && _section_image$list4$.full_path ? section_image === null || section_image === void 0 ? void 0 : (_section_image$list5 = section_image.list) === null || _section_image$list5 === void 0 ? void 0 : (_section_image$list5$ = _section_image$list5[0]) === null || _section_image$list5$ === void 0 ? void 0 : _section_image$list5$.full_path : 'https://res.cloudinary.com/dgxoa4a9i/image/upload/page/shanta-easytrade/1686937289h8eHd.webp',
        alt: 'Shanta Securities Limited',
        objectFit: 'cover',
        layout: 'fill'
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(react_bootstrap__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsxs)(react_bootstrap__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
          children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(react_bootstrap__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
            sm: 10,
            children: section_data !== null && section_data !== void 0 && section_data.subtitle && no == false ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("h2", {
              className: 'split-up',
              children: (0,react_html_parser__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .ZP)(section_data !== null && section_data !== void 0 && section_data.subtitle ? section_data === null || section_data === void 0 ? void 0 : section_data.subtitle : 'Want to explore new opportunities?')
            }) : /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("h2", {
              className: '',
              children: (0,react_html_parser__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .ZP)(section_data !== null && section_data !== void 0 && section_data.subtitle ? section_data === null || section_data === void 0 ? void 0 : section_data.subtitle : 'Want to explore new opportunities?')
            })
          }), winWidth && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("div", {
            className: "bottom-text-wrap ",
            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(react_bootstrap__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
              sm: 9,
              className: 'cta',
              children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsxs)("div", {
                className: "bottom-text-wrap__box",
                children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("h4", {
                  className: '',
                  children: section_data !== null && section_data !== void 0 && section_data.short_desc ? section_data === null || section_data === void 0 ? void 0 : section_data.short_desc : 'Attain financial freedom at the tip of your fingertips?'
                }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(Button, {
                  icon: true,
                  src: 'contact',
                  width: '200',
                  hoverBackground: '#221F1F',
                  background: 'transparent',
                  color: '#fff',
                  text: 'Contact Us'
                })]
              })
            })
          })]
        })
      })]
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(StyleMobile, {
      children: winWidth < 767 ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("div", {
        className: "bottom-text-wrap ",
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(react_bootstrap__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
          sm: 9,
          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsxs)("div", {
            className: "bottom-text-wrap__box",
            children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("h4", {
              className: '',
              children: section_data !== null && section_data !== void 0 && section_data.short_desc ? section_data === null || section_data === void 0 ? void 0 : section_data.short_desc : 'Want to explore new opportunities?'
            }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(Button, {
              icon: true,
              src: 'contact',
              width: '200',
              hoverBackground: '#221F1F',
              background: 'transparent',
              color: '#fff',
              text: 'Contact Us'
            })]
          })
        })
      }) : ''
    })]
  });
};

var StyledLube = styled_components__WEBPACK_IMPORTED_MODULE_10__/* ["default"].section.withConfig */ .ZP.section.withConfig({
  displayName: "CTA-v3__StyledLube",
  componentId: "sc-xno92b-0"
})(["position:relative;padding-top:100px;padding-bottom:120px;.hide{display:none;}h2{color:#ffffff;margin:0 0 90px 0;}@media (min-width:1550px){padding-top:250px;padding-bottom:250px;.bottom-text-wrap__box{padding-top:calc(76.5714%) !important;min-height:300px !important;max-width:30%;min-width:400px !important;h4{top:50px !important;left:50px !important;right:50px !important;}.dc-btn{left:50px !important;bottom:50px !important;}}.bottom-text-wrap{bottom:-140px !important;}}p{font-size:16px;line-height:22px;font-weight:600;margin:0;color:#ffffff;}.bottom-text-wrap{position:absolute;left:", "px;bottom:-110px;z-index:9;&__box{background-color:", ";padding-top:calc(268 / 270 * 100%);max-width:25%;min-height:220px;bottom:0px;position:absolute;min-width:320px;h4{font-family:", ";color:#ffffff;margin:0;font-size:20px;line-height:28px;font-weight:500;position:absolute;top:40px;left:40px;right:40px;}.dc-btn{position:absolute;left:40px;bottom:40px;}}}@media (max-width:1150px){.bottom-text-wrap__box{h4{font-size:25px;line-height:28px;}}}@media (max-width:1020px){.bottom-text-wrap{.col-sm-6{min-width:100% !important;margin:0;p{margin-bottom:40px;}}}}@media (max-width:767px){padding:125px 0 !important;.bottom-text-wrap{position:relative;left:unset;right:unset;bottom:unset;width:100%;.col-sm-9{padding-right:0;padding-left:0;}}.bottom-text-wrap__box{position:relative;left:unset;right:unset;bottom:unset;width:100%;max-width:100%;min-height:unset;height:auto !important;min-width:100%;padding-top:60%;}h2{margin:0;}}@media (max-width:600px){padding-top:60px;h1{margin-bottom:38px;font-size:32px;line-height:36px;font-weight:600;}.bottom-text-wrap .col-sm-3{max-width:calc(100% - 50px);min-width:calc(100% - 50px);.bottom-text-wrap__box{height:270px;padding-top:0;h4{font-size:32px;line-height:36px;}}}}@media (max-width:350px){.bottom-text-wrap .col-sm-3{min-width:100%;}}@media (min-width:1500px){.bottom-text-wrap__box{padding-top:calc(268 / 350 * 100%);}}"], function (props) {
  return props.offset ? props.offset - 15 : '0';
}, _styles_globalStyleVars__WEBPACK_IMPORTED_MODULE_11__/* .hover */ .Mr, _styles_globalStyleVars__WEBPACK_IMPORTED_MODULE_11__/* .hover */ .Mr);
var StyleMobile = styled_components__WEBPACK_IMPORTED_MODULE_10__/* ["default"].section.withConfig */ .ZP.section.withConfig({
  displayName: "CTA-v3__StyleMobile",
  componentId: "sc-xno92b-1"
})(["display:none;.bottom-text-wrap{&__box{background-color:", ";h4{font-family:", ";color:#ffffff;margin:0;font-size:20px;line-height:28px;font-weight:500;position:absolute;top:40px;left:40px;right:40px;}.dc-btn{position:absolute;left:40px;bottom:40px;}}}@media (max-width:767px){display:block;.bottom-text-wrap{position:relative;left:unset;right:unset;bottom:unset;width:100%;.col-sm-9{padding-right:0;padding-left:0;}}.bottom-text-wrap__box{position:relative;left:unset;right:unset;bottom:unset;width:100%;max-width:100%;min-height:unset;height:auto !important;min-width:100%;min-height:200px;}}"], _styles_globalStyleVars__WEBPACK_IMPORTED_MODULE_11__/* .hover */ .Mr, _styles_globalStyleVars__WEBPACK_IMPORTED_MODULE_11__/* .hover */ .Mr);
/* harmony default export */ __webpack_exports__["default"] = (/*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.memo(SpecialtyLube));

/***/ }),

/***/ 68019:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "E": function() { return /* binding */ Img; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(68777);
/* harmony import */ var react_lazy_load_image_component_src_effects_blur_css__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(68893);
/* harmony import */ var react_lazy_load_image_component_src_effects_blur_css__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(react_lazy_load_image_component_src_effects_blur_css__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(85893);





var Img = function Img(_ref) {
  var nolazy = _ref.nolazy,
      visible = _ref.visible,
      srcSm = _ref.srcSm,
      src = _ref.src,
      position = _ref.position,
      objectFit = _ref.objectFit,
      height = _ref.height,
      width = _ref.width,
      banner = _ref.banner,
      alt = _ref.alt,
      left = _ref.left,
      margin = _ref.margin,
      right = _ref.right,
      top = _ref.top,
      bottom = _ref.bottom;
  var DefaultBanner = '/images/static/blurbg.svg';

  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(0),
      deviceWidth = _useState[0],
      setDeviceWidth = _useState[1]; // set device width


  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
    function HandleWidth() {
      setDeviceWidth(window.innerWidth);
    }

    window.addEventListener('resize', HandleWidth);
    HandleWidth();
    return function () {
      window.removeEventListener('resize', HandleWidth);
    };
  });
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(StyledImg, {
    className: "global-image",
    srcSm: srcSm,
    objectFit: objectFit,
    margin: margin,
    position: position,
    left: left,
    right: right,
    top: top,
    bottom: bottom,
    height: height,
    width: width,
    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_2___default()), {
      quality: 100,
      priority: true,
      blurDataURL: "".concat(DefaultBanner),
      alt: alt || 'Shanta Securities Limited',
      objectFit: 'cover',
      layout: 'fill',
      src: src ? deviceWidth > 600 ? src : srcSm ? srcSm : src : DefaultBanner // use normal <img> attributes as props

    })
  });
};
var StyledImg = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "Img__StyledImg",
  componentId: "sc-1091rec-0"
})(["position:", ";height:", ";width:", ";top:", ";left:", ";bottom:", ";right:", ";margin:", ";img{width:100%;height:100%;object-fit:", ";position:absolute;top:0;left:0;right:0;bottom:0;}"], function (props) {
  return props.position || 'absolute';
}, function (props) {
  return props.height || '100%';
}, function (props) {
  return props.width || '100%';
}, function (props) {
  return props.top || 0;
}, function (props) {
  return props.left || 0;
}, function (props) {
  return props.bottom || 0;
}, function (props) {
  return props.right || 0;
}, function (props) {
  return props.margin || 0;
}, function (props) {
  return props.objectFit || 'cover';
});

/***/ }),

/***/ 98508:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "E": function() { return /* binding */ Img; }
/* harmony export */ });
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(68777);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var react_lazy_load_image_component__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(72679);
/* harmony import */ var react_lazy_load_image_component__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(react_lazy_load_image_component__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react_lazy_load_image_component_src_effects_blur_css__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(68893);
/* harmony import */ var react_lazy_load_image_component_src_effects_blur_css__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(react_lazy_load_image_component_src_effects_blur_css__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(85893);






var Img = function Img(_ref) {
  var src = _ref.src,
      visible = _ref.visible,
      speed = _ref.speed,
      position = _ref.position,
      objectFit = _ref.objectFit,
      height = _ref.height,
      width = _ref.width,
      banner = _ref.banner,
      alt = _ref.alt,
      left = _ref.left,
      margin = _ref.margin,
      right = _ref.right,
      top = _ref.top,
      bottom = _ref.bottom;
  // const smoother = useContext(SmootherContext);
  //
  // useEffect(() => {
  //     smoother.effects("img", {speed: "auto"})
  // }, [])
  var DefaultBanner = '/images/static/blurbg.svg';
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(StyledImg, {
    className: "global-image  ",
    objectFit: objectFit,
    margin: margin,
    position: position,
    left: left,
    right: right,
    top: top,
    bottom: bottom,
    height: height,
    width: width,
    children: src && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_3___default()), {
      quality: 100,
      priority: true,
      blurDataURL: "".concat(DefaultBanner),
      placeholder: "blur",
      objectFit: 'cover',
      layout: 'fill',
      alt: alt || 'Shanta Securities Limited',
      src: src || DefaultBanner // use normal <img> attributes as props

    })
  });
};
var StyledImg = styled_components__WEBPACK_IMPORTED_MODULE_5__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "ImgP__StyledImg",
  componentId: "sc-ncc5rv-0"
})(["position:", ";height:", ";width:", ";top:", ";left:", ";bottom:", ";right:", ";margin:", ";overflow:hidden;img{width:100%;height:130%;object-fit:", ";position:absolute;top:-50px;left:0;right:0;bottom:0;will-change:transform;}"], function (props) {
  return props.position || 'absolute';
}, function (props) {
  return props.height || '100%';
}, function (props) {
  return props.width || '100%';
}, function (props) {
  return props.top || 0;
}, function (props) {
  return props.left || 0;
}, function (props) {
  return props.bottom || 0;
}, function (props) {
  return props.right || 0;
}, function (props) {
  return props.margin || 0;
}, function (props) {
  return props.objectFit || 'cover';
});

/***/ }),

/***/ 8711:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _ImgP__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(98508);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(68777);
/* harmony import */ var react_bootstrap__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(10682);
/* harmony import */ var react_bootstrap__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(21608);
/* harmony import */ var react_bootstrap__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(31555);
/* harmony import */ var react_html_parser__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(30653);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(85893);








var InnerbannerV9 = function InnerbannerV9(_ref) {
  var full = _ref.full,
      title = _ref.title,
      text = _ref.text,
      project = _ref.project,
      id = _ref.id,
      src = _ref.src,
      vh = _ref.vh,
      data = _ref.data;
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(StyledInnerBanner, {
    id: "".concat(id ? id : 'InnerBanner'),
    full: full,
    vh: vh,
    className: "InnerBanner ".concat(project ? 'project_banner' : ''),
    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("div", {
      className: "InnerBanner__parallax",
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsxs)("div", {
        className: "blur_image parallax",
        children: [src && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(_ImgP__WEBPACK_IMPORTED_MODULE_0__/* .Img */ .E, {
          src: src,
          alt: title
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(react_bootstrap__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(react_bootstrap__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsxs)("div", {
              className: "flex_box ",
              children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(react_bootstrap__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                md: 7,
                children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("div", {
                  className: "title",
                  children: title && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("h1", {
                    "data-lag": '0.4',
                    children: (0,react_html_parser__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)(title)
                  })
                })
              }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(react_bootstrap__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                md: 5,
                children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("div", {
                  className: "text",
                  children: text && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("p", {
                    "data-lag": '0.4',
                    children: (0,react_html_parser__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)(text)
                  })
                })
              })]
            })
          })
        })]
      })
    })
  });
};

var StyledInnerBanner = styled_components__WEBPACK_IMPORTED_MODULE_7__/* ["default"].section.withConfig */ .ZP.section.withConfig({
  displayName: "innerbanner-v9__StyledInnerBanner",
  componentId: "sc-1lkjrda-0"
})(["position:relative;.InnerBanner__parallax{padding-top:", ";position:relative;@media (min-width:1550px){padding-top:", ";}@media (max-width:767px){padding-top:", ";}.flex_box{display:flex;justify-content:space-between;align-items:flex-end;width:100%;@media (max-width:767px){flex-direction:column;text-align:left;align-items:flex-start;}.text{position:relative;z-index:2;display:flex;justify-content:flex-end;@media (max-width:767px){display:block;justify-content:unset;}p{font-size:16px;font-weight:500;line-height:24px;color:#FFFFFF;@media (max-width:767px){text-align:left;br{}}}}}.blur_image{width:100%;height:100%;position:absolute;left:0;right:0;bottom:0;}.container{position:absolute;margin:0 auto;z-index:2;bottom:100px;left:0;right:0;@media (max-width:767px){bottom:40px;}h1{z-index:2;font-size:44px;line-height:56px;letter-spacing:-1px;margin:30px 0 0;font-weight:500;color:#FFFFFF;font-family:'Avenir';@media (max-width:767px){font-size:36px;line-height:42px;margin-bottom:15px;}}}}@media (min-width:1550px){}@media (max-width:767px){.InnerBanner__parallax{padding-top:", ";.container{bottom:40px;h1{font-size:40px;line-height:40px;margin:0px 0 20px;}}.flex_box{flex-direction:column;text-align:left;align-items:flex-start;.title{width:100%;}.text{display:block;justify-content:unset;p{width:100%;text-align:left;br{}}}}}}"], function (props) {
  return props.full ? '100vh' : 'calc(560 / 1366 * 100%)';
}, function (props) {
  return props.full ? '100vh' : 'calc(560 / 1366 * 100%)';
}, function (props) {
  return props.full ? '100vh' : 'calc(560 / 375 * 100%)';
}, function (props) {
  return props.full ? '100vh' : '70vh';
});
/* harmony default export */ __webpack_exports__["Z"] = (/*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.memo(InnerbannerV9));

/***/ }),

/***/ 11267:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "j": function() { return /* binding */ ApiParamKey; }
/* harmony export */ });
var ApiParamKey = {
  TYPE: 'type',
  PAGE_ID: 'page_id',
  PAGE_SLUG: 'page_slug',
  VALUE: 'value',
  GET_SECTION: 'get_section',
  IMAGE: 'image',
  POST: 'post',
  FILE: 'file',
  GALLERY: 'gallery',
  LIMIT: 'limit',
  VARIATION: 'variation',
  SPECIFICATION: 'specification',
  KEYWORD: 'keyword',
  PARENTPAGE: 'parent_page_id',
  DIVISION_ID: 'division_id',
  RADIUS: 'radius',
  KEY: 'key',
  CATEGORY_ID: 'category_id',
  DATE: 'date',
  FILTER: 'filter',
  TIME: 'timestamp',
  STARTDATE: 'start_date',
  ENDDATE: 'end_date'
};

/***/ })

}]);